import React, { useState, useEffect, useRef, useMemo } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';

import { Calendar } from 'primereact/calendar';
import GeneralUtils from '../../utilities/GeneralUtils';

const CompetitionJobCalendarEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);
    const [canEditStartDate, setCanEditStartDate] = useState(null);

    const toast = useRef(null);
    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        let _competition = GeneralUtils.emptyInNullForObjectFields(props?.value);

        // console.log(_competition);
        setCompetition(_competition);
        setCanEditStartDate(_competition?.status === 'DRAFT');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetitionCalendar = (data) => {
        competitionService.saveCompetitionJobCalendar(data)
            .then((savedCompetition) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedCompetition.competition, true, null);
                }
                hideDialog();
            })
            .catch((error) => {
                // console.log("error: ", error);
                props.afterSave(null, false, error);
            });
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition ? competition : props.value,
        validate: (data) => {
            let errors = {};

            // console.log("validation: ", data);

            if (!data.startDate) {
                errors.startDate = translatedMessage('form.error.competition.job.startDate.required');
            }
            if (!data.writtenTestDate) {
                errors.writtenTestDate = translatedMessage('form.error.competition.writtenTestDate.required');
            }
            if (!data.writtenTestLocation || data.writtenTestLocation.trim() === '') {
                errors.writtenTestLocation = translatedMessage('form.error.competition.writtenTestLocation.required');
            }

            if(GeneralUtils.daysBetweenDates(data.startDate, data.writtenTestDate, true) < 30) {
                errors.writtenTestDate = translatedMessage('form.error.competition.writtenTestDate.toEarly', 30);
            }

            return errors;
        },
        onSubmit: (data) => {
            let _data = { ...GeneralUtils.nullIfEmptyForObjectFields(data) };
            // console.log("competition calendar saved: ", _data);
            saveCompetitionCalendar(_data);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const formDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="field-form" type="submit" />
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props?.visible}
                header={translatedMessage('competition.calendar.dialog.title')}
                modal
                className="pcn-dialog-small"
                footer={formDialogFooter}
                onHide={hideDialog}
            >
                <form id="field-form" onSubmit={formik.handleSubmit}>
                    <div className='grid'>
                        <div className='col-12'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <Calendar
                                        id="startDate"
                                        name="startDate"
                                        value={formik.values.startDate}
                                        onChange={formik.handleChange}
                                        dateFormat="dd-mm-yy"
                                        className={classNames({ 'p-invalid': isFormFieldValid('startDate') })}
                                        disabled={!canEditStartDate}
                                    />
                                    <label htmlFor="startDate" className={classNames({ 'p-error': isFormFieldValid('startDate') })}>
                                        {translatedMessage("competition.job.startDate")} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('startDate')}
                            <div className='mt-1 text-ligh-grey'>{translatedMessage("competition.calendar.info")}</div>
                        </div>

                        <div className="col-12 mt-3"><div className='font-bold'>{translatedMessage("competition.writtenTest")}</div></div>
                        <div className='col-12'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <Calendar
                                        id="writtenTestDate"
                                        name="writtenTestDate"
                                        value={formik.values.writtenTestDate}
                                        onChange={formik.handleChange}
                                        dateFormat="dd-mm-yy"
                                        showTime
                                        hourFormat="24"
                                        stepMinute={10}
                                        onShow={() => { if (!formik.values.writtenTestDate) { formik.setFieldValue("writtenTestDate", GeneralUtils.roundDateTimeHour(0)) } }}
                                        className={classNames({ 'p-invalid': isFormFieldValid('writtenTestDate') })}
                                        // disabled={!competition?.canEditWrittenTestDate}
                                    />
                                    <label htmlFor="writtenTestDate" className={classNames({ 'p-error': isFormFieldValid('writtenTestDate') })}>
                                        {translatedMessage('competition.exam.dateHour')} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('writtenTestDate')}
                        </div>

                        <div className='col-12'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputText type="text" name="writtenTestLocation" id="writtenTestLocation"
                                        value={formik.values.writtenTestLocation} onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('writtenTestLocation') })} 
                                        // disabled={!competition?.canEditWrittenTestDate}
                                    />
                                    <label htmlFor="writtenTestLocation" className={classNames({ 'p-error': isFormFieldValid('writtenTestLocation') })}>
                                        {translatedMessage("competition.exam.location")} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('writtenTestLocation')}
                        </div>



                    </div>
                </form>
            </Dialog >
        </>
    );
};

export default CompetitionJobCalendarEditDialog;
